export const CUSTOMER_FUEL_REQUEST_RECEIPT =
  'fuel_request/v1/customer_fuel_request_receipt';
export const REASON_SATISFACTION_LIST = 'info/v1/reason_satisfaction_list';
export const CUSTOMER_SURVEY_ADD_BY_LINK = 'fuel_request/v1/customer_survey_add_by_link';
export const APP_VERSION = 'setting/v1/app_version';
